import { CampoAlteracao } from "../../types";
import { TableContainer } from "../../../DemandaCriada/styles";
import styled from "styled-components";

const StyledTableContainer = styled(TableContainer)`
    .data-table {
        font-size: 10px;

        thead {
            th {
                font-size: 10px;
            }
        }

        tbody {
            tr {
                td {
                    font-size: 10px;

                    &.before-cell {
                        color: var(--c64748b) !important;
                    }

                    &.after-cell {
                        color: var(--c000000) !important;
                        padding-left: 8px !important;
                    }
                }
            }
        }
    }
`;


interface BlocoAlteracoesProps {
    campos: CampoAlteracao[];
}

export default function BlocoAlteracoes({ campos }: BlocoAlteracoesProps) {
    if (campos.length === 0) {
        return null;
    }

    return (
        <div className="expanded-section">
            <h4 className="section-title">Principal</h4>
            <StyledTableContainer>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th className="field-col">Campo</th>
                            <th className="before-col">Antes</th>
                            <th className="after-col">Depois</th>
                        </tr>
                    </thead>
                    <tbody>
                        {campos.map((campo, i) => (
                            <tr key={i} className={i > 0 ? 'border-top' : ''}>
                                <td className="field-cell">{campo.campo}</td>
                                <td className={`before-cell ${campo.antes === '—' ? 'empty-value' : ''}`}>
                                    {campo.antes}
                                </td>
                                <td className={`after-cell ${campo.depois === '—' ? 'empty-value' : ''}`}>
                                    {campo.depois}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </StyledTableContainer>
        </div>
    );
}

